var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"scroll-top",attrs:{"id":"scrollTop","href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.scrollTop()}}},[_c('span',{staticClass:"material-icons"},[_vm._v(" keyboard_arrow_up ")])])}
var staticRenderFns = []

export { render, staticRenderFns }